import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { EditorModule } from 'primeng/editor';
import { InputTextModule } from 'primeng/inputtext';
import { FileUploadModule } from 'primeng/fileupload';
import { ImageModule } from 'primeng/image';
import { ButtonModule } from 'primeng/button';
import { UserService } from '../../../layout/service/user.service';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { AccordionModule } from 'primeng/accordion';
import { AvatarModule } from 'primeng/avatar';
import { BadgeModule } from 'primeng/badge';



@Component({
    selector: 'app-add-form-quiz-details',
    standalone: true,
    imports: [
        CommonModule, FormsModule, EditorModule, InputTextModule, FileUploadModule, ImageModule, ButtonModule,
        ToastModule, PdfViewerModule, AccordionModule, AvatarModule, BadgeModule
    ],
    providers: [MessageService],
    template: `
        <p-toast />
        <p-progressSpinner *ngIf="loading" styleClass="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-30 z-50" strokeWidth="4" animationDuration=".5s"></p-progressSpinner>
        <div class="mt-8 mx-auto max-w-3xl">
            <div class="sticky top-16 px-6 py-4 shadow-md bg-white rounded-lg flex justify-between items-center mb-8 z-20">
                <h2 class="text-2xl font-bold text-primary">{{ isEditMode ? 'Ubah Soal' : 'Tambah Soal' }}</h2>
                <ng-container *ngIf="!isEditMode">
                    <p-button
                        (click)="saveQuestions()"
                        label="Simpan Soal"
                        icon="pi pi-save"
                        severity="info"
                        [raised]="true"
                        variant="contained"
                        type="button"
                        pTooltip="Simpan semua soal yang telah diisi"
                        tooltipPosition="left"
                    />
                </ng-container>
                <ng-container *ngIf="isEditMode">
                    <p-button
                        (click)="editQuestion()"
                        label="Perbarui Soal"
                        icon="pi pi-check"
                        severity="success"
                        [raised]="true"
                        variant="contained"
                        type="button"
                        pTooltip="Perbarui soal ini"
                        tooltipPosition="left"
                    />
                </ng-container>
            </div>
            <p-accordion value="0" [multiple]="true" class="mb-10">
                <p-accordion-panel *ngFor="let detail of details; let i = index" [header]="'Soal #' + (i + 1)" [value]="i">
                    <p-accordion-header>
                        <span class="flex flex-col w-full">
                            <span class="flex items-center gap-2 w-full">
                                <p-avatar [label]="(i+1).toString()" shape="circle" styleClass="bg-primary text-white" />
                                <span class="font-bold whitespace-nowrap">Soal #{{ i + 1 }}</span>
                            </span>
                        </span>
                    </p-accordion-header>
                    <p-accordion-content>
                        <div class="bg-white rounded-lg shadow-md p-8 relative">
                            <div class="flex justify-between items-center mb-6">
                                <p-button
                                    severity="danger"
                                    [raised]="true"
                                    label="Hapus"
                                    icon="pi pi-trash"
                                    *ngIf="details.length > 1 && !isEditMode"
                                    (click)="removeQuestion(i)"
                                    pTooltip="Hapus soal ini"
                                    tooltipPosition="left"
                                />
                            </div>
                            <div class="mb-6">
                                <label class="block mb-2 font-medium text-gray-700">Deskripsi</label>
                                <div class="bg-gray-50 rounded border border-gray-200 p-2">
                                    <p-editor [(ngModel)]="detail.description" [style]="{ height: '180px' }" name="description{{ i }}"></p-editor>
                                </div>
                            </div>
                            <div class="mb-6" *ngIf="isFlatArray(cases?.field)">
                                <label class="block mb-2 font-medium text-gray-700">Gambar</label>
                                <div class="flex items-center gap-4">
                                    <p-fileupload
                                        mode="basic"
                                        chooseLabel="Pilih"
                                        chooseIcon="pi pi-upload"
                                        name="demo[]"
                                        url="https://www.primefaces.org/cdn/api/upload.php"
                                        accept="image/*"
                                        maxFileSize="1000000"
                                        [auto]="true"
                                        (onUpload)="onUpload($event, i)"
                                        pTooltip="Unggah gambar pendukung (opsional)"
                                        tooltipPosition="right"
                                    />
                                    <div class="mt-2">
                                        <p-image [src]="detail.image" alt="Gambar Terunggah" width="120" [preview]="true" *ngIf="detail.image"></p-image>
                                    </div>
                                </div>
                            </div>
                            <!-- Grouped image upload -->
                            <div class="mb-6" *ngIf="!isFlatArray(cases?.field)">
                                <label class="block mb-2 font-medium text-gray-700">Gambar per Group</label>
                                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div *ngFor="let group of cases?.field; let gi = index" class="mb-3">
                                        <div class="flex items-center gap-4">
                                            <span class="font-semibold">{{ group.name }}</span>
                                            <p-fileupload
                                                mode="basic"
                                                chooseLabel="Pilih"
                                                chooseIcon="pi pi-upload"
                                                name="groupImage{{gi}}"
                                                url="https://www.primefaces.org/cdn/api/upload.php"
                                                accept="image/*"
                                                maxFileSize="1000000"
                                                [auto]="true"
                                                (onUpload)="onGroupImageUpload($event, i, gi, group.name)"
                                                pTooltip="Unggah gambar untuk {{ group.name }}"
                                                tooltipPosition="right"
                                            />
                                            <div class="mt-2">
                                                <p-image [src]="getGroupImage(detail, gi)" alt="Gambar Terunggah" width="120" [preview]="true" *ngIf="getGroupImage(detail, gi)"></p-image>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="mb-6">
                                <label class="block mb-2 font-medium text-gray-700">Kolom Tambahan</label>
                                <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                                    <!-- Jika data adalah array of string -->
                                    <div *ngIf="isFlatArray(cases?.field); else groupedFields">
                                        <div *ngFor="let field of cases?.field; let fi = index" class="mb-3">
                                            <label class="block text-sm mb-1 text-gray-600">{{ field || 'Kolom Tanpa Nama ' + (fi + 1) }}</label>
                                            <input pInputText
                                                [(ngModel)]="detail.answer[fi].value"
                                                (ngModelChange)="onAnswerChange(i, fi, $event)"
                                                placeholder="Masukkan..."
                                                class="w-full bg-gray-50 border border-gray-200 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary"
                                            />
                                        </div>
                                    </div>
                                    <!-- Jika data adalah array of object { name, fields } -->
                                    <ng-template #groupedFields>
                                        <div *ngFor="let group of cases?.field; let gi = index" class="mb-4">
                                            <h3 class="text-md font-bold mt-2 mb-3 text-gray-700">{{ group.name }}</h3>
                                            <div *ngFor="let field of group.fields; let fi = index" class="mb-3">
                                                <label class="block text-sm mb-1 text-gray-600">{{ field || 'Kolom Tanpa Nama ' + (fi + 1) }}</label>
                                                <input pInputText
                                                    [ngModel]="getGroupedAnswerValue(detail, gi, fi)"
                                                    (ngModelChange)="setGroupedAnswerValue(i, gi, fi, $event)"
                                                    placeholder="Masukkan..."
                                                    class="w-full bg-gray-50 border border-gray-200 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary"
                                                />
                                            </div>
                                        </div>
                                    </ng-template>
                                </div>
                            </div>
                            <div>
                                <label class="block mb-2 font-medium text-gray-700">Penjelasan (PDF)</label>
                                <div class="flex items-center gap-4">
                                    <p-fileupload
                                        mode="basic"
                                        chooseLabel="Unggah PDF"
                                        chooseIcon="pi pi-upload"
                                        name="explanationPdf{{i}}"
                                        accept="application/pdf"
                                        maxFileSize="5000000"
                                        [auto]="false"
                                        (onSelect)="onExplanationSelect($event, i)"
                                        pTooltip="Unggah file PDF penjelasan (opsional)"
                                        tooltipPosition="right"
                                    />
                                    <div class="mt-2 text-sm text-green-700" *ngIf="getExplanationFileName(detail.explanation)">
                                        PDF terunggah: <span class="font-semibold">{{ getExplanationFileName(detail.explanation) }}</span>
                                        <pdf-viewer
                                            *ngIf="getExplanationPdfSrc(detail.explanation)"
                                            [src]="getExplanationPdfSrc(detail.explanation)"
                                            [render-text]="true"
                                            [original-size]="false"
                                            style="width: 320px; height: 400px"
                                        ></pdf-viewer>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </p-accordion-content>
                </p-accordion-panel>
            </p-accordion>
            <div class="flex justify-end mt-6" *ngIf="!isEditMode">
                <p-button
                    label="Tambah Soal"
                    icon="pi pi-plus"
                    [raised]="true"
                    (click)="cloneQuestion()"
                    class="px-6 py-3 text-base font-semibold"
                    pTooltip="Tambah soal baru"
                    tooltipPosition="left"
                />
            </div>
        </div>
    `
})
export class AddFormQuizDetails implements OnInit {
    @Input() cases!: {
        id: string;
        field: string[];
    };
    @Input() editDetail?: any; // detail object to edit
    @Input() editIndex?: number; // index if needed
    @Output() finishEdit = new EventEmitter<void>();
    @Output() allComplete = new EventEmitter<boolean>();

    details: any[] = [];
    isEditMode: boolean = false;
    loading = false;

    constructor(
        private userService: UserService,
        private messageService: MessageService
    ){}

    initializeAnswerFields() {
        return this.cases?.field.map(fieldName => ({
            field: fieldName,
            value: ''
        })) || [];
    }

    // Tambahkan images untuk grouped field
    initializeImagesFields() {
        if (Array.isArray(this.cases?.field) && typeof this.cases.field[0] === 'object') {
            return this.cases.field.map((group: any) => ({
                name: group.name,
                image: ''
            }));
        }
        return [];
    }

    ngOnInit(): void {
        if (this.editDetail) {
            this.isEditMode = true;
            const parsedAnswer = Array.isArray(this.editDetail.answer)
                ? this.editDetail.answer
                : (typeof this.editDetail.answer === 'string' ? JSON.parse(this.editDetail.answer) : []);
            // Untuk grouped image
            let images = [];
            if (Array.isArray(this.cases?.field) && typeof this.cases.field[0] === 'object') {
                if (Array.isArray(this.editDetail.images)) {
                    images = this.editDetail.images;
                } else {
                    images = this.initializeImagesFields();
                }
            }
            this.details = [{
                form_case_id: this.cases?.id,
                description: this.editDetail.description || '',
                explanation: this.editDetail.explanation || '',
                answer: this.cases?.field.map((field: string, idx: number) => ({
                    field,
                    value: parsedAnswer[idx]?.value ?? ''
                })) || [],
                image: this.editDetail.image || '',
                images // grouped images
            }];
        } else {
            // Add mode
            this.details = [
                {
                    form_case_id: this.cases?.id,
                    description: '',
                    explanation: '',
                    answer: this.initializeAnswerFields(),
                    image: '',
                    images: this.initializeImagesFields()
                }
            ];
        }
    }

    onAnswerChange(detailIndex: number, fieldIndex: number, value: string) {
        this.details[detailIndex].answer[fieldIndex].value = value;
    }

    cloneQuestion() {
        this.details.push({
            form_case_id: this.cases?.id,
            description: '',
            explanation: '',
            answer: this.initializeAnswerFields(),
            image: ''
        });
    }

    isFlatArray(field: any): boolean {
        return Array.isArray(field) && typeof field[0] === 'string';
    }

    removeQuestion(index: number) {
        if (this.details.length > 1) {
            this.details.splice(index, 1);
        }
    }

    onUpload(event: any, index: number) {
        const uploadedFile = event.files?.[0];
        if (uploadedFile) {
            const reader = new FileReader();
            reader.onload = () => {
                this.details[index].image = reader.result as string;
            };
            reader.readAsDataURL(uploadedFile);
        }
    }

    onExplanationSelect(event: any, index: number) {
        const uploadedFile = event.files?.[0];
        if (uploadedFile && uploadedFile.type === 'application/pdf') {
            const reader = new FileReader();
            reader.onload = () => {
                this.details[index].explanation = JSON.stringify({
                    name: uploadedFile.name,
                    data: reader.result as string
                });
            };
            reader.readAsDataURL(uploadedFile);
        } else {
            this.details[index].explanation = '';
        }
    }

    getExplanationFileName(explanation: string): string {
        if (!explanation) return '';
        try {
            const obj = JSON.parse(explanation);
            return obj.name || '';
        } catch {
            return '';
        }
    }

    getExplanationPdfSrc(explanation: string): string | undefined {
        if (!explanation) return undefined;
        try {
            const obj = JSON.parse(explanation);
            return typeof obj.data === 'string' ? obj.data : undefined;
        } catch {
            return undefined;
        }
    }

    // Untuk grouped image upload
    onGroupImageUpload(event: any, detailIndex: number, groupIndex: number, groupName: string) {
        const uploadedFile = event.files?.[0];
        if (uploadedFile) {
            const reader = new FileReader();
            reader.onload = () => {
                if (!this.details[detailIndex].images) {
                    this.details[detailIndex].images = this.initializeImagesFields();
                }
                this.details[detailIndex].images[groupIndex] = {
                    name: groupName,
                    image: reader.result as string
                };
            };
            reader.readAsDataURL(uploadedFile);
        }
    }

    getGroupImage(detail: any, groupIndex: number): string {
        return detail.images?.[groupIndex]?.image || '';
    }

    // Helper to build answer array for flat and grouped fields
    buildAnswerForSave(detail: any): any[] {
        // Flat array: ["Rate", ...]
        if (Array.isArray(this.cases?.field) && typeof this.cases.field[0] === 'string') {
            return [
                {
                    name: '',
                    form: (this.cases.field as string[]).map((field: string, idx: number) => ({
                        field,
                        value: detail.answer?.[idx]?.value ?? ''
                    }))
                }
            ];
        }
        // Grouped array: [{name, fields: [...]}, ...]
        if (Array.isArray(this.cases?.field) && typeof this.cases.field[0] === 'object') {
            // Only include group if image is not empty
            return (this.cases.field as any[]).map((group: any, gi: number) => {
                const groupImage = detail.images?.[gi]?.image;
                if (!groupImage) {
                    return null; // skip this group
                }
                return {
                    name: group.name,
                    form: (group.fields || []).map((field: string, fi: number) => ({
                        field,
                        value: detail.answer?.[gi]?.[fi]?.value ?? ''
                    }))
                };
            }).filter(Boolean); // remove nulls
        }
        return [];
    }

    saveQuestions() {
        this.loading = true;
        const promises = this.details.map(detail => {
            const updatedDetail: any = {
                ...detail,
                answer: JSON.stringify(this.buildAnswerForSave(detail)),
            };
            if (Array.isArray(this.cases?.field) && typeof this.cases.field[0] === 'object') {
                // Only keep images with non-empty image
                updatedDetail.images = (detail.images || []).filter((img: any) => img && img.image);
                delete updatedDetail.image;
            }
            return this.userService.addFormDetails(updatedDetail);
        });

        Promise.all(promises)
            .then(() => {
                this.details = [];
                this.messageService.add({ severity: 'success', summary: 'Berhasil', detail: 'Semua soal berhasil ditambahkan' });
            })
            .catch((error) => {
                this.messageService.add({ severity: 'error', summary: 'Gagal', detail: error.message });
            })
            .finally(() => {
                this.loading = false;
            });
    }

    editQuestion() {
        this.loading = true;
        const detail = this.details[0];
        const payload: any = {
            id: this.editDetail.id,
            form_case_id: this.cases?.id,
            description: detail.description,
            answer: JSON.stringify(this.buildAnswerForSave(detail)),
        };
        if (Array.isArray(this.cases?.field) && typeof this.cases.field[0] === 'object') {
            // Only keep images with non-empty image
            payload.images = (detail.images || []).filter((img: any) => img && img.image);
        } else if (detail.image) {
            payload.image = detail.image;
        }
        if (detail.explanation) {
            payload.explanation = detail.explanation;
        }
        this.userService.updateFormDetails(payload)
            .then(() => {
                this.messageService.add({ severity: 'success', summary: 'Berhasil', detail: 'Soal berhasil diperbarui' });
                this.finishEdit.emit();
            })
            .catch((error: any) => {
                this.messageService.add({ severity: 'error', summary: 'Gagal', detail: error.message });
            })
            .finally(() => {
                this.loading = false;
            });
    }

    getIncompleteFields(detail: any): string[] {
        const incomplete: string[] = [];
        // Cek deskripsi
        if (!detail.description || detail.description.trim() === '') {
            incomplete.push('Deskripsi');
        }
        // Cek kolom jawaban
        if (Array.isArray(detail.answer)) {
            // Flat array: gunakan nama field asli
            if (Array.isArray(this.cases?.field) && typeof this.cases.field[0] === 'string') {
                (this.cases.field as string[]).forEach((field: string, idx: number) => {
                    const label = field || `Kolom Tanpa Nama ${idx + 1}`;
                    if (!detail.answer[idx] || !detail.answer[idx].value || detail.answer[idx].value.trim() === '') {
                        incomplete.push(label);
                    }
                });
            }
        } else if (typeof detail.answer === 'object' && detail.answer !== null) {
            // Grouped array: gunakan nama group dan nama field asli
            if (Array.isArray(this.cases?.field) && typeof this.cases.field[0] === 'object') {
                (this.cases.field as any[]).forEach((group: any, gi: number) => {
                    const groupName = group?.name || `Group ${gi + 1}`;
                    if (group && Array.isArray(group.fields)) {
                        group.fields.forEach((field: string, fi: number) => {
                            const fieldLabel = field || `Kolom Tanpa Nama ${fi + 1}`;
                            if (
                                !detail.answer[gi] ||
                                !detail.answer[gi][fi] ||
                                !detail.answer[gi][fi].value ||
                                detail.answer[gi][fi].value.trim() === ''
                            ) {
                                incomplete.push(`${groupName} - ${fieldLabel}`);
                            }
                        });
                    }
                });
            }
        }
        return incomplete;
    }

    // Helper for grouped fields: get value
    getGroupedAnswerValue(detail: any, groupIdx: number, fieldIdx: number): string {
        return detail.answer?.[groupIdx]?.[fieldIdx]?.value ?? '';
    }

    // Helper for grouped fields: set value
    setGroupedAnswerValue(detailIndex: number, groupIdx: number, fieldIdx: number, value: string) {
        // Ensure the answer array is initialized
        if (!Array.isArray(this.details[detailIndex].answer)) {
            this.details[detailIndex].answer = [];
        }
        if (!Array.isArray(this.details[detailIndex].answer[groupIdx])) {
            this.details[detailIndex].answer[groupIdx] = [];
        }
        if (!this.details[detailIndex].answer[groupIdx][fieldIdx]) {
            this.details[detailIndex].answer[groupIdx][fieldIdx] = { value: '' };
        }
        this.details[detailIndex].answer[groupIdx][fieldIdx].value = value;
    }
}
